import React, { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

// section の上に乗る軽量 label の単一 spec.
// SOAP body の S/O/A、文字起こしタブの ハイライト/メモ/発話、 処方タブの 今回/前回 等、
// 各タブ内の section heading を全てこの component で統一する.
// 変更時はこの file 1 箇所のみ修正で 3 タブ全てに反映される.
// spacing (mb 等) は context 依存のため caller で sx 経由 override.
interface SectionHeadingProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export const SectionHeading: FC<SectionHeadingProps> = ({ children, sx }) => (
  <Typography
    variant="caption"
    sx={[
      {
        display: 'block',
        fontWeight: 600,
        color: 'text.secondary',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Typography>
)
